import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="question-card"
// When "other" is selected, only the textarea has the param name so its value is submitted as the question
// answer. When a non-other option is selected, only the radios have the param name. Ensures a single param.
export default class extends Controller {
  static targets = ["radioGroup", "otherInput", "textInput"]
  static values = {
    otherValue: String,
    paramName: String
  }

  connect() {
    this.updateOtherInputVisibility()
  }

  toggleOtherInput() {
    this.updateOtherInputVisibility()
  }

  updateOtherInputVisibility() {
    if (!this.hasOtherInputTarget) return

    const selectedRadio = this.radioGroupTarget.querySelector("input[type='radio']:checked")
    const isOtherSelected = selectedRadio && this.isOtherValue(selectedRadio.value)

    if (isOtherSelected) {
      this.otherInputTarget.classList.remove("hidden")
      const textarea = this.otherInputTarget.querySelector("textarea")
      if (textarea) {
        textarea.focus()
      }
    } else {
      this.otherInputTarget.classList.add("hidden")
    }

    this.updateParamNames(isOtherSelected)
  }

  // Only one element has the param name at a time so a single value is submitted for the question.
  updateParamNames(isOtherSelected) {
    if (!this.hasParamNameValue) return
    const name = this.paramNameValue
    const textarea = this.hasOtherInputTarget ? this.otherInputTarget.querySelector("textarea") : null
    const radios = this.hasRadioGroupTarget ? this.radioGroupTarget.querySelectorAll("input[type='radio']") : []

    if (isOtherSelected) {
      if (textarea) textarea.name = name
      radios.forEach((radio) => { radio.name = "" })
    } else {
      if (textarea) textarea.name = ""
      radios.forEach((radio) => { radio.name = name })
    }
  }

  // Match "other", "others", or label like "Other (please specify)" (radios use option[:label] as value).
  isOtherValue(value) {
    const normalized = (value || "").toLowerCase().trim()
    return normalized === "other" || normalized === "others" || normalized.startsWith("other ")
  }
}
